/*
 * @Author: Merlin
 * @Date: 2023-12-14 13:32:45
 * @LastEditors: Merlin
 * @LastEditTime: 2024-05-03 13:26:38
 * @Description: 
 */


export const useBalance1Socket = () => {
    // 👇 在余额变化后将收到余额，比如在下注之后 
    const ON_BALANCES = (callback: any) => {
        // 从 Joe 处了解到，下面的 balance 有实际值，其它属性未启用，值为0 
        // 返回数据示例： {usdt: {balance: 6276.72001438, cashback: 0, rakeBackValue: 0, rakeBackValueUSD: 0}}
        socket.on(`balances`, callback);
    };
    return {
        ON_BALANCES,
    };
};


